import { z } from 'zod';
import { apiSend } from './http';
import { LoginResponse, TwoFactorConfigureResponse, TwoFactorVerifyResponse } from './authSchemas';

export const login = (
  email: string,
  password: string,
  clientDeviceId?: string
): Promise<LoginResponse> =>
  apiSend('POST', '/auth/login', { email, password, clientDeviceId }, LoginResponse);

/** Calls that run while the 2FA token is the bearer pass it explicitly. */
const withBearer = (token: string): RequestInit => ({
  headers: { Authorization: `Bearer ${token}` }
});

/** Body as the portal sent it: `enabled` always true, `smsFallback` + `phone` for SMS. */
export const configureTwoFactor = (
  twoFactorToken: string,
  body: { method: 'app' | 'sms'; phone?: string }
): Promise<TwoFactorConfigureResponse> =>
  apiSend(
    'POST',
    '/auth/two-factor/configure',
    body.method === 'sms'
      ? { enabled: true, smsFallback: true, phone: body.phone }
      : { enabled: true, smsFallback: false },
    TwoFactorConfigureResponse,
    withBearer(twoFactorToken)
  );

export const verifyTwoFactor = (
  twoFactorToken: string,
  body: { twoFactorToken?: string; recoveryCode?: string; saveDevice?: boolean }
): Promise<TwoFactorVerifyResponse> =>
  apiSend(
    'POST',
    `/auth/two-factor/verify${body.recoveryCode !== undefined ? '?recovery=true' : ''}`,
    body,
    TwoFactorVerifyResponse,
    withBearer(twoFactorToken)
  );

export const resendTwoFactorSms = (twoFactorToken: string): Promise<unknown> =>
  apiSend('POST', '/auth/two-factor/resend', undefined, z.unknown(), withBearer(twoFactorToken));

export const logout = (): Promise<unknown> => apiSend('POST', '/auth/logout');
